import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `GrupoUsuario/editGruposUsuario`, method: 'POST', body: values, token: token})
}